import React from 'react'

function Home() {
  return (
    <div className='p-5 text-center'>
      <h1 className='text-6xl font-bold mb-5'>HOME</h1>
      <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Autem repellendus fuga nesciunt quisquam esse provident quam officiis et vitae possimus cupiditate illo sequi odit earum natus eius magni, aperiam alias perferendis in deleniti voluptatum ipsa! Velit, perspiciatis laborum beatae voluptatum quae iure aliquid consectetur soluta ratione quis, vero blanditiis esse? Quae eum accusantium eaque at, alias perferendis quia qui veritatis amet harum provident mollitia itaque magni labore ex expedita quasi. Quasi vero accusantium, nam fugiat ratione minus. Aspernatur eius, culpa doloremque natus consequatur dolore voluptate ipsa, at dolor suscipit atque ullam nemo quas fuga. Vero natus excepturi vel ea suscipit.</p>
    </div>
  )
}

export default Home
